import { createToken } from '../react'

interface LogoutMessage {
  token: string
  data?: any
}

interface LogoutArgs {
  extraQueryParams?: Record<string, string | number | boolean>
}

/**
 * Class to manage the logout from other tabs, it uses a broadcast channel
 * to listen or send logout signals to other tabs. There should be a single instance
 * of this class for the entire application.
 */
export class LogoutManager {
  private channel: BroadcastChannel
  private token: string

  private callback: (message: MessageEvent<LogoutMessage>) => void
  private onLogout!: (args?: LogoutArgs) => void

  constructor() {
    this.channel = new BroadcastChannel('logout_broadcast')
    this.token = createToken()
    this.callback = this.onMessageReceived.bind(this)
  }

  /**
   * set the logout callback to be invoked when
   * another tab triggers a logout
   */
  public setOnLogoutReceived(onLogout: () => void) {
    this.onLogout = onLogout
    this.channel.addEventListener('message', this.callback)
  }

  /**
   * cleanup the onLogout callback
   */
  public cleanOnLogoutReceived() {
    this.channel.removeEventListener('message', this.callback)
  }

  /**
   * signal other tabs that a logout has ben initiated
   */
  public sendLogoutMessage() {
    this.channel.postMessage({
      token: this.token,
      data: 'logout',
    })
  }

  private onMessageReceived(message: MessageEvent<LogoutMessage>) {
    const { token } = message.data
    if (token !== this.token) {
      const logoutArgs = {
        extraQueryParams: { logoutBroadcast: true },
      }
      this.onLogout(logoutArgs)
    }
  }
}
